var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{staticStyle:{"width":"217px"},attrs:{"placeholder":"请输入内容"},on:{"change":_vm.changeInput},model:{value:(_vm.propValue),callback:function ($$v) {_vm.propValue=$$v},expression:"propValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }